// extracted by mini-css-extract-plugin
module.exports = {"main":"ordersPage_textInput_main__J79eQ","disabled":"ordersPage_textInput_disabled__xYcvI"};